import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestGet } from "../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../data/network/services/ApiRequestPost";
import { authAction } from "../../../data/redux/action/authAction";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../../data/redux/action/fullScreenLoadingAction";
import { validateEmail } from "../../../utility/emailValidator";
import ResizeListener from "../../../utility/ResizeListener";
import secureStorage from "../../../utility/secureStorage";
import { CustomButton } from "../../components/customButton/CustomButton";
import { CustomInput } from "../../components/customInput/CustomInput";
import CustomPasswordInput from "../../components/CustomPasswordInput";
import { NeokredNewLogo } from "../../resources/assetsManager";
import {
  BLACK_COLOR,
  LOGIN_BG_COLOR,
  WHITE_COLOR,
} from "../../resources/colorsManager";
import { SUCCESS } from "../../resources/constantsManager";
import {
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_MOBILE_NUMBER,
  SS_REF_HASH_ID,
  SS_ROLE,
  SS_TOKEN,
} from "../../resources/secureStorageManager";
function Login({ onClick }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { height, width } = ResizeListener();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [showVerifiedEmail, setShowVerifiedEmail] = useState(false);
  const navigate = useNavigate();

  const onClickLoginClient = () => {
    dispatch(startFullScreenLoadingAction());
    setLoading(true);
    ApiRequestPost.authenticate(email, password)
      .then((res) => {
        console.log("SUCCESS RESPONSE FROM LOGIN - AUTHENTICATE API => ", res);
        if (res.data) {
          secureStorage.setItem(SS_TOKEN, res.data);

          onClickLoginWithoutOtp(password, email);
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message || err, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        dispatch(stopFullScreenLoadingAction());
      });
  };

  const onClickLoginWithoutOtp = (password, username) => {
    setLoading(true);
    ApiRequestPost.verifyWithoutOtp({
      password,
      username,
    })
      .then((data) => {
        if (data.status === SUCCESS) {
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          secureStorage.setItem(SS_REF_HASH_ID, data?.data?.refHashId);
          secureStorage.setItem(SS_MOBILE_NUMBER, data?.data?.mobileNumber);
          secureStorage.setItem(SS_EMAIL, data?.data?.email);
          secureStorage.setItem(SS_FIRST_NAME, data?.data?.firstName);
          secureStorage.setItem(SS_ROLE, data?.data?.role);
          secureStorage.setItem(SS_LAST_NAME, data?.data?.lastName);
          secureStorage.setItem("setupTime", new Date().getTime());
          dispatch(authAction(true));
          navigate("/dashboard");
        } else {
          enqueueSnackbar(data.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  const checkUser = (email) => {
    ApiRequestGet.checkUser(email)
      .then((data) => {
        if (data.status === SUCCESS) {
          setShowVerifiedEmail(true);
        } else {
          setShowVerifiedEmail(false);
        }
      })
      .catch((error) => {
        setShowVerifiedEmail(false);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (
      password.length >= 12 &&
      password.length <= 16 &&
      email !== "" &&
      passwordValid
    ) {
      setDisabled(false);
    } else setDisabled(true);
    return () => {};
  }, [password, email, passwordValid]);
  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: WHITE_COLOR,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />

        {/* <Carasoule /> */}
      </div>
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: LOGIN_BG_COLOR,
          flexDirection: "column",
          height,
          // backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "400",
              fontSize: 15,
              color: "#2D3748",
              margin: 0,
            }}
            className="roboto"
          >
            Welcome back
          </p>
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              marginBottom: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            Login to your account
          </p>
          <div style={{ marginTop: "25px" }}>
            <p style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}>
              Email<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomInput
              type={"input"}
              title="Email"
              value={email}
              placeholder="Enter Email"
              onChange={(data) => {
                setEmail(data);
                if (validateEmail(data)) {
                  checkUser(data);
                } else {
                  setShowVerifiedEmail(false);
                }
              }}
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              validator="email"
              isRightIconRequired={showVerifiedEmail}
              rightIcon={
                <img
                  src={require("../../../assets/png/animated.gif")}
                  width={30}
                  height={30}
                  alt="Show Verified Email"
                  style={{}}
                />
              }
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <p style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}>
              Password<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomPasswordInput
              value={password}
              onChange={setPassword}
              placeholder="Enter Password"
              isError={(data) => setPasswordValid(data)}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></div>

            <p
              style={{
                fontSize: 14,
                color: "#3783FB",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/forgotpassword");
              }}
              className="roboto"
            >
              Forgot password?
            </p>
          </div>
          <CustomButton
            loading={loading}
            title="Login"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 15,
              height: "50px",
            }}
            textStyles={{
              color: WHITE_COLOR,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              onClickLoginClient();
            }}
            disabled={disabled}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                // onClickLoginClient();
                // onClickLoginWithoutOtp(email, password);
                onClickLoginClient();
              }
            }}
          />

          <CustomButton
            title="Don't have an account? Sign up"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 15,
              height: "50px",
              backgroundColor: "transparent",
              border: "1px solid rgb(26, 32, 44)",
            }}
            textStyles={{
              fontSize: 15,
              fontWeight: "500",
              color: BLACK_COLOR,
            }}
            onClick={() => {
              // onClickLoginClient();
              navigate("/register");
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
